import GoogleMap from "./google-map/index";
import Calendar from "./calendar/calendar";
import {gsap} from "gsap";
import {getSiblings} from "./helpers";

/**
 * Calls a supplied function once
 * document has loaded.
 *
 * @param  {CallableFunction} onLoaded
 * @return {void}
 */

const domLoaded = (onLoaded) => {
	if (document.readyState !== 'loading') {
		// Document is already ready, call the callback directly
		onLoaded();
	} else if (document.addEventListener) {
		// All modern browsers to register DOMContentLoaded
		document.addEventListener('DOMContentLoaded', onLoaded);
	} else {
		// Old IE browsers
		document.attachEvent('onreadystatechange', function () {
			if (document.readyState === 'complete') {
				onLoaded();
			}
		});
	}
};

const App = {
	init() {
		if (document.querySelectorAll('.events-swiper') && 'undefined' !== typeof Swiper) {
			Array.from(document.querySelectorAll('.events-swiper')).map((sw) => {
				const wrapper = sw.closest('.events-swiper-wrapper');
				const hugeDate = wrapper.querySelector('.huge-date');
				const slides = sw.querySelectorAll('.swiper-slide');
				const swiper = new Swiper(sw, {
					navigation: {
						nextEl: wrapper.querySelector('.swiper-button-next-custom'),
						prevEl: wrapper.querySelector('.swiper-button-prev-custom'),
					},
					on: {
						init: function () {
							const firstSlide = slides[0];
							hugeDate.innerText = `${firstSlide.dataset.month || ''} ${firstSlide.dataset.day || ''}`;
						},
						slideChange: function (s) {
							const currentSlide = slides[s.realIndex];
							hugeDate.innerText = `${currentSlide.dataset.month || ''} ${currentSlide.dataset.day || ''}`;
						},
					},
					effect: "creative",
					creativeEffect: {
						// limitProgress: 2,
						prev: {
							shadow: true,
							translate: [0, "100%", -800],
							opacity: 0,
						},
						next: {
							shadow: true,
							translate: [0, "-30%", -400],
							rotate: [0, 0, 0],
							opacity: .8,
						},
					},
				});
			});
		}

		if (document.querySelectorAll('.view-also-swiper') && 'undefined' !== typeof Swiper) {
			Array.from(document.querySelectorAll('.view-also-swiper')).map((sw) => {
				const wrapper = sw.closest('.view-also-swiper-wrapper');
				const swiper = new Swiper(sw, {
					navigation: {
						nextEl: wrapper.querySelector('.swiper-button-next-custom'),
						prevEl: wrapper.querySelector('.swiper-button-prev-custom'),
					},
					// grabCursor: true,
					centeredSlides: true,
					slidesPerView: 1.2,
					spaceBetween: 12,
					breakpoints: {
						460: {
							centeredSlides: false,
							slidesPerView: 'auto',
							spaceBetween: 24,
						}
					}
				});
			});
		}

		if (document.querySelectorAll('.members-swiper') && 'undefined' !== typeof Swiper) {
			Array.from(document.querySelectorAll('.members-swiper')).map((sw) => {
				const swiper = new Swiper(sw, {
					grabCursor: true,
					loop: true,
					autoplay: {
						delay: 2000,
						disableOnInteraction: false,
					},
					slidesPerView: 2,
					spaceBetween: 12,
					breakpoints: {
						960: {
							slidesPerView: 4,
						}
					}
				});
			});
		}

		if (document.querySelectorAll('.gallery-swiper') && 'undefined' !== typeof Swiper) {
			Array.from(document.querySelectorAll('.gallery-swiper')).map((sw) => {
				const wrapper = sw.closest('.gallery-swiper-wrapper');
				const swiper = new Swiper(sw, {
					navigation: {
						nextEl: wrapper.querySelector('.swiper-button-next-custom'),
						prevEl: wrapper.querySelector('.swiper-button-prev-custom'),
					},
					// grabCursor: true,
					slidesPerView: 'auto',
					spaceBetween: 24,
				});
			});
		}

		if (document.querySelectorAll('.labels-swiper') && 'undefined' !== typeof Swiper) {
			Array.from(document.querySelectorAll('.labels-swiper')).map((sw) => {
				const wrapper = sw.closest('.labels-swiper-wrapper');
				const swiper = new Swiper(sw, {
					navigation: {
						nextEl: wrapper.querySelector('.swiper-button-next-custom'),
						prevEl: wrapper.querySelector('.swiper-button-prev-custom'),
					},
					// grabCursor: true,
					slidesPerView: 'auto',
					spaceBetween: 24,
				});
			});
		}

		function concatValues( obj ) {
			let value = '';
			for ( var prop in obj ) {
				value += obj[ prop ];
			}
			return value;
		}

		if (document.querySelectorAll('.isotope-grid') && 'undefined' !== typeof Isotope) {
			Array.from(document.querySelectorAll('.isotope-grid')).map((isotopeEl) => {
				const iso = new Isotope( isotopeEl, {
					itemSelector: '.grid-item',
					layoutMode: isotopeEl.dataset.layout || 'fitRows',
				});

				let filters = {};

				const varietyFilter = document.getElementById('variety-filter');
				const regionFilter = document.getElementById('region-filter');
				const categoryFilter = document.getElementById('category-filter');
				const tagFilter = document.getElementById('tag-filter');

				if (varietyFilter) {
					varietyFilter.addEventListener('change', (event) => {
						const filterGroup = event.target.dataset.filterGroup;
						filters[ filterGroup ] = event.target.value;
						iso.arrange({filter: concatValues( filters )});

					window.innerWidth < 1024 && isotopeEl.scrollIntoView({ behavior: "smooth", block: "start" });
					});
				}

				if (regionFilter) {
					regionFilter.addEventListener('change', (event) => {
						const filterGroup = event.target.dataset.filterGroup;
						filters[ filterGroup ] = event.target.value;
						iso.arrange({filter: concatValues( filters )});

						window.innerWidth < 1024 && isotopeEl.scrollIntoView({ behavior: "smooth", block: "start" });
					});
				}

				if (categoryFilter) {
					categoryFilter.addEventListener('change', (event) => {
						const filterGroup = event.target.dataset.filterGroup;
						filters[ filterGroup ] = event.target.value;
						iso.arrange({filter: concatValues( filters )});

						window.innerWidth < 1024 && isotopeEl.scrollIntoView({ behavior: "smooth", block: "start" });
					});
				}

				if (tagFilter) {
					tagFilter.addEventListener('change', (event) => {
						const filterGroup = event.target.dataset.filterGroup;
						filters[ filterGroup ] = event.target.value;
						iso.arrange({filter: concatValues( filters )});

						window.innerWidth < 1024 && isotopeEl.scrollIntoView({ behavior: "smooth", block: "start" });
					});
				}
			});
		}

		if (document.getElementById('map-results')) {
			const gmap = new GoogleMap(document.getElementById('map-results'));

			if (document.querySelectorAll('.map-toggle')) {
				Array.from(document.querySelectorAll('.map-toggle')).map((button) => {
					button.addEventListener('click', function(event){
						if (event.currentTarget.classList.contains('is-map')) {
							event.currentTarget.classList.add('hidden');
							document.querySelector('.map-toggle.is-grid').classList.remove('hidden');
							document.getElementById('grid-results').classList.add('hidden');
							document.getElementById('map-results').classList.remove('hidden');
						} else if(event.currentTarget.classList.contains('is-grid')){
							event.currentTarget.classList.add('hidden');
							document.querySelector('.map-toggle.is-map').classList.remove('hidden');
							document.getElementById('grid-results').classList.remove('hidden');
							document.getElementById('map-results').classList.add('hidden');
						}
					}, false);
				});
				// document.getElementById('map-toggle').addEventListener('click', function(event) {
				// 	if (event.currentTarget.classList.contains('is-grid')) {
				// 		document.getElementById('grid-results').classList.add('hidden');
				// 		document.getElementById('map-results').classList.remove('hidden');
				// 		event.currentTarget.classList.remove('is-grid');
				// 		event.currentTarget.classList.add('is-map');
				// 	} else {
				// 		document.getElementById('grid-results').classList.remove('hidden');
				// 		document.getElementById('map-results').classList.add('hidden');
				// 		event.currentTarget.classList.add('is-grid');
				// 		event.currentTarget.classList.remove('is-map');
				// 	}
				// }, false);
			}
		}

		if (document.getElementById('member-map-container')) {
			const memberMap = new GoogleMap(document.getElementById('member-map-container'));
		}

		if (document.getElementById('contact-map-container')) {
			const contactMap = new GoogleMap(document.getElementById('contact-map-container'));
		}

		if (document.getElementById('calendar')) {
			const calendar = new Calendar(document.getElementById('calendar'));
		}

		if (document.querySelector('.navbar')) {
			const burger = document.querySelector('.burger');
			const mainMenuWrapper = document.querySelector('.main-menu-wrapper');

			const openMainMenu = () => {
				document.body.classList.add('main-menu-open');
				gsap.to(mainMenuWrapper, {
					yPercent: 100,
					duration: .75,
					ease: 'power4.out'
				});
			}

			const closeMainMenu = () => {
				document.body.classList.remove('main-menu-open');
				gsap.to(mainMenuWrapper, {
					yPercent: 0,
					ease: 'power4.out'
				});
			}


			burger.addEventListener('click', (ev) => {
				if (!document.body.classList.contains('main-menu-open')) {
					openMainMenu();
				} else {
					closeMainMenu();
				}
			});
		}

		const keyDownHandler = (e) => {
			if (e.code === 'KeyM') {
				if (document.body.classList.contains('navbar-style-light')) {
					document.body.classList.remove('navbar-style-light');
					document.body.classList.add('navbar-style-dark');
				} else {
					document.body.classList.remove('navbar-style-dark');
					document.body.classList.add('navbar-style-light');
				}
			}
		};
		document.addEventListener('keydown', keyDownHandler);

		// Homepage Tabs
		const tabItems = document.querySelectorAll('.tab-item');
		if (tabItems) {
			const areaEl = document.getElementById('tab-total-area');
			const wineriesEl = document.getElementById('tab-total-wineries');
			const varietiesEl = document.getElementById('tab-total-varieties');
			const imageEl = document.getElementById('tab-small-image');

			const tabScroller = document.getElementById('tab-scroller');

			Array.from(tabItems).map((item, index) => {
				item.addEventListener('click', (e) => {
					const siblings = getSiblings(e.currentTarget);
					Array.from(siblings).map((sibling) => sibling.classList.remove('active'));
					e.currentTarget.classList.add('active');

					if (areaEl) areaEl.innerText = item.dataset.area;
					if (wineriesEl) wineriesEl.innerText = item.dataset.wineries;
					if (varietiesEl) varietiesEl.innerText = item.dataset.varieties;
					// if (imageEl) imageEl.src = item.dataset.image;

					if (tabScroller && window.innerWidth < 1024) tabScroller.scrollIntoView({behavior: "smooth", block: "start"})
				})
			});
		}

		// Member Tabs
		const memberTabs = document.querySelectorAll('.member-tabs .tab');
		if (memberTabs) {
			const tabContent = document.querySelector('.members-tabs-container');
			Array.from(memberTabs).map((tab, index) => {
				tab.addEventListener('click', (event) => {
					const selectedTab = event.currentTarget;
					getSiblings(selectedTab).map((s) => s.classList.remove('active'));
					selectedTab.classList.add('active');
					const target = selectedTab.dataset.target;
					const t = tabContent.querySelector(`.tab-target[data-tab="${target}"]`);
					getSiblings(t).map((s) => s.classList.add('hidden'));
					t.classList.remove('hidden');
				});
			});
		}

		if (document.getElementById('dropdownLangMenuLink')) {
			const dropdownLangMenuLink = document.getElementById('dropdownLangMenuLink');
			dropdownLangMenuLink.addEventListener('click', (event) => {
				event.preventDefault();
				const menuEl = document.querySelector('[aria-labelledby="dropdownLangMenuLink"]');
				console.log(menuEl);

				if (!dropdownLangMenuLink.classList.contains('show')) {
					// Show the language menu
					dropdownLangMenuLink.classList.add('show');
					dropdownLangMenuLink.setAttribute('aria-expanded', 'true');
					menuEl.classList.remove('hidden');
				} else {
					// Hide the language menu
					dropdownLangMenuLink.classList.remove('show');
					dropdownLangMenuLink.setAttribute('aria-expanded', 'false');
					menuEl.classList.add('hidden');
				}
			})
		}

		if (document.getElementById('newsletter-popup') && document.getElementById('newsletter-link') ) {
			const popupEl = document.getElementById('newsletter-popup');
			const newsletterLink = document.getElementById('newsletter-link');

			newsletterLink.addEventListener('click', (event) => {
				event.preventDefault();
				popupEl.classList.remove('hidden');
			});

			const closeButton = popupEl.querySelector('.close-button');
			const closePopup = () => {
				popupEl.classList.add('hidden');
			}
			closeButton.addEventListener('click', closePopup);
		}
	}
};

domLoaded(() => {
	App.init();
});
